import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%)',
  },
  card: {
    background: '#fff',
    padding: '2.5rem 2rem',
    borderRadius: '1.25rem',
    boxShadow: '0 8px 32px rgba(60,72,100,0.12)',
    minWidth: 340,
    maxWidth: 360,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    fontWeight: 700,
    fontSize: '3.5rem',
    marginBottom: '1.5rem',
    color: '#6366f1',
    letterSpacing: 1,
    fontFamily: 'Caveat, cursive',
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    margin: '0.5rem 0',
    borderRadius: '0.5rem',
    border: '1px solid #e5e7eb',
    fontSize: '1rem',
    outline: 'none',
    transition: 'border 0.2s',
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    margin: '1rem 0 0.5rem 0',
    borderRadius: '0.5rem',
    border: 'none',
    background: '#000000',
    color: '#fff',
    fontWeight: 600,
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  forgotPassword: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '0.85rem',
    alignSelf: 'flex-end',
    marginTop: '0.25rem',
    cursor: 'pointer',
  },
  divider: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: '1.25rem 0',
    gap: '0.75rem',
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    background: '#e5e7eb',
  },
  dividerText: {
    color: '#9ca3af',
    fontSize: '0.8rem',
  },
  registerButton: {
    width: '100%',
    padding: '0.75rem',
    borderRadius: '0.5rem',
    border: '1px solid #e5e7eb',
    background: 'transparent',
    color: '#374151',
    fontWeight: 500,
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.2s',
    textDecoration: 'none',
    textAlign: 'center',
    display: 'block',
  },
  error: {
    color: '#ef4444',
    fontSize: '0.95rem',
    marginTop: 4,
  },
};

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      navigate('/invites');
    }
  }, [navigate]);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const res = await fetch(`${API_URL}/api/event-invites/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Login failed.');
        return;
      }
      // Login successful, store token
      sessionStorage.setItem('token', data.token);
      navigate('/invites');
    } catch (err) {
      setError('Login failed.');
    }
  };

  return (
    <div style={styles.container}>
      <form style={styles.card} onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={require('../assets/top_logo.png')}
            alt="Invite Avenue Logo"
            style={{ width: '20vw', height: '30vh', objectFit: 'contain'}}
          />
        </div>
        <input
          style={styles.input}
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          style={styles.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        <Link style={styles.forgotPassword} to="/forgot-password" state={{ email }}>Forgot password?</Link>
        {error && <div style={styles.error}>{error}</div>}
        <button style={styles.button} type="submit">Login</button>
        <div style={styles.divider}>
          <span style={styles.dividerLine}></span>
          <span style={styles.dividerText}>or</span>
          <span style={styles.dividerLine}></span>
        </div>
        <Link style={styles.registerButton} to="/register">Create an account</Link>
      </form>
    </div>
  );
} 